import React, { useState } from 'react'
import PropTypes from 'prop-types'
import SimpleBlockContent from '../../../SimpleBlockContent'
import CategoryTitle from '../../../CategoryTitle'
import Cta from '../../../Cta'
import Modal from '../../../Modal'
import Youtube from '../../../Youtube'
import Text from '../../../Text'
import Spacer from '../../../Spacer'
import styles from './styles.module.css'
import { $neutralGray80, $white } from '../../../../styles/colors/primitives'



function HeaderGallery1Page({ page = {}, totalPages, pageIndex, carouselKey, isPageHero = false }) {
  const { title, text, backgroundImage, ctas, flipped, sideImage, category = { title: '', color: {} }, videoUrl, theme = {}, titleAlignment, sideImagePosition = 'Center' } = page
  // Single-<h1> rule (Audit A #1): /coaching carries TWO headerGallery1 sections,
  // each a carousel of pages that ALL render into the DOM. Promote a title to the
  // document <h1> ONLY for the FIRST page of the page-hero gallery (isPageHero &&
  // pageIndex === 0) so exactly one visible <h1> exists. `<Text primary>` keeps the
  // `h1` variant's visual class and only swaps the tag to <h1>.
  const isDocumentH1 = isPageHero && pageIndex === 0
  // Phase B: the video-player open flag is LOCAL component state (per gallery page).
  const [showVideoModal, setShowVideoModal] = useState(false)

  const themeColorValue = theme.title.match(/\d+/) ? Number(theme.title.match(/\d+/)[0]) : null
  const textColor = themeColorValue && themeColorValue > 40 ? $white : $neutralGray80
  const dark = themeColorValue && themeColorValue < 50

  // task #67: backgroundImage/sideImage are ResolvedImage descriptors; the styled
  // bg takes .src (hotspot is no longer carried by the descriptor).
  const imageUrl = backgroundImage ? backgroundImage.src : false
  // $neutralGray20 = #E0E0E0 default; colorWhite/colorBlack per imageUrl presence
  const wrapperStyle = {
    backgroundColor: theme.value || '#E0E0E0',
    color: imageUrl ? '#fff' : '#000',
    // Guard the CSS url(): when there is no backgroundImage, imageUrl is the
    // boolean `false`, and `url(false)` makes the browser fetch `<origin>/false`
    // (404) on every HeaderGallery1-without-bg page (e.g. /coaching). Emit no
    // background-image instead — visually identical (a 404 paints nothing either
    // way), just without the wasted 404. Mirrors the guarded pattern used by every
    // other section (e.g. PictureAndText: `sideImage?.src ? url(...) : undefined`).
    // Caught by the console-health candidate gate (first-party on-origin 404).
    backgroundImage: imageUrl ? `url(${imageUrl})` : undefined,
  }
  return (
    <div className={styles.wrapper} style={wrapperStyle}>
      {titleAlignment === 'Center' ? <Spacer size={64} /> : <Spacer size={160} />}
      {backgroundImage && <div className={styles.imageShadow} />}
      <div className={styles.centered}>
      {titleAlignment === 'Center' && <div className={styles.centeredTitleWrapper}>
        {category.title.length > 0 && <div>
          <Spacer size={64} />
          <CategoryTitle color={category.color.value}>{category.title}</CategoryTitle>
        </div>}
        <Spacer size={16} />
        <div className={styles.title} style={{ color: textColor }}><Text type="h1" primary={isDocumentH1}>{title}</Text></div>
        <Spacer size={32} />
        </div>}
        <div className={flipped ? styles.contentWrapperFlipped : styles.contentWrapper}>
          <div className={flipped ? `${styles.mainContent} ${styles.mainContentFlipped}` : styles.mainContent}>
            {titleAlignment !== 'Center' && <div>
              {category.title.length > 0 && <div>
                <Spacer size={64} />
                <CategoryTitle color={category.color.value}>{category.title}</CategoryTitle>
              </div>}
              <Spacer size={16} />
              <div className={styles.title} style={{ color: textColor }}><Text type="h1" primary={isDocumentH1}>{title}</Text></div>
              <Spacer size={32} />
            </div>}
            <div className={styles.textBlock} style={{ color: textColor }}>
              {text && <SimpleBlockContent blocks={text} />}
            </div>
            <Spacer size={64} />
            {ctas && (
              <div className={styles.ctas}>
                {ctas.map((cta) => (
                  <Cta {...cta} key={cta._key} dark={dark}/>
                ))}
              </div>
            )}
            <Spacer size={160} />
            <Spacer size={64} />
          </div>
          {videoUrl && <div className={styles.playIconWrapper}>
            <button className={styles.videoLink} onClick={() => setShowVideoModal(true)}>
              {/* eslint-disable-next-line @next/next/no-img-element */}
              {/* eslint-disable-next-line local-rules/prefer-img-component -- inline chrome icon (play), hand-sized 64x64 from /public */}
              <img src="/playIcon.svg" alt="Play video" width={64} height={64} decoding="async" />
            </button>
          </div>}
          {sideImage && <div className={sideImagePosition === 'Bottom' ? styles.sideImageAlignBottom : styles.sideImage} style={{ backgroundImage: `url(${sideImage?.src})` }} />}
        </div>
      </div>
      {videoUrl && <Modal show={showVideoModal} onClose={() => setShowVideoModal(false)}>
        <div className={styles.youtubeWrapper}>
          <button className={styles.closeButton} onClick={() => setShowVideoModal(false)}>
            {/* eslint-disable-next-line @next/next/no-img-element */}
            {/* eslint-disable-next-line local-rules/prefer-img-component -- inline chrome icon (close), hand-sized 24x24 from /public */}
            <img src="/crossIcon.svg" alt="Close" width={24} height={24} decoding="async" />
          </button>
          <Youtube autoplay modestbranding url={videoUrl} width="100%" height="100%" />
        </div>
      </Modal>}
    </div>
  )
}

HeaderGallery1Page.propTypes = {
  page: PropTypes.object,
  totalPages: PropTypes.number,
  pageIndex: PropTypes.number,
}

export default HeaderGallery1Page
